<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.brands.index">
        <template v-slot:title>
          <span>{{ $t("brands.self") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="5" md="6" sm="12" xl="5">
              <b-form-group :label="$t('brands.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('brands.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"

                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="true">
                  {{ $t('brands.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>
            <b-col lg="5" md="6" sm="12" xl="5">
              <b-form-group :label="$t('brands.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('brands.description')"
                    class="form-control form-control-solid"
                    :state="validateState('description')"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="true">
                  {{ $t('brands.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="2" md="6" sm="12" xl="2">
              <b-form-group :label="$t('brands.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/brand.module";
import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "BrandsCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
  },
  components: {
    DashboardBox
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      },
      status: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        name: null,
        description: null,
        status: true
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: "management.brands"})
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);

      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "brands.edit_item" : "brands.create_item")}
    ]);

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    item(value) {

      if (value) {
        let item = value.item;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }
        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self
              .sweetAlertSuccess(self.$t("general.successfully_saved"), (response) => {
                if (response) {
                  self.$router.push({ name: "management.brands"});
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
